import { render, staticRenderFns } from "./home_footer.vue?vue&type=template&id=75e62642&scoped=true"
import script from "./home_footer.vue?vue&type=script&lang=js"
export * from "./home_footer.vue?vue&type=script&lang=js"
import style0 from "./home_footer.vue?vue&type=style&index=0&id=75e62642&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e62642",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75e62642')) {
      api.createRecord('75e62642', component.options)
    } else {
      api.reload('75e62642', component.options)
    }
    module.hot.accept("./home_footer.vue?vue&type=template&id=75e62642&scoped=true", function () {
      api.rerender('75e62642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/home_footer.vue"
export default component.exports